import { useParams } from "react-router";

const PREVIEW = () => {
  const params = useParams();
  return (
    <div className="flex flex-col w-full pb-12 overflow-y-auto h-full ">
      <iframe
        title={params.link}
        className="w-full h-full"
        // src={`https://${params.link}`}
        src={`http://localhost:3000`}
      ></iframe>
    </div>
  );
};

export default PREVIEW;
